import { render, staticRenderFns } from "./FullPageModal.vue?vue&type=template&id=af0dcff2&lang=pug&"
import script from "./FullPageModal.vue?vue&type=script&lang=ts&"
export * from "./FullPageModal.vue?vue&type=script&lang=ts&"
import style0 from "./FullPageModal.vue?vue&type=style&index=0&id=af0dcff2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports